"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  item: {
    marginBottom: theme.spacing(3)
  },
  itemAccordion: {
    borderBottom: `1px solid ${theme.palette?.grey?.[300]}`,
    marginBottom: 0
  },
  accordion: {
    background: "none",
    borderRadius: "0 !important",
    boxShadow: "none"
  },
  subAccordion: {
    background: "none",
    borderRadius: "0 !important",
    boxShadow: "none",
    marginBottom: "0 !important",
    marginTop: "0 !important",
    "&::before": {
      backgroundColor: theme.palette?.grey?.[300]
    }
  },
  accordionLabel: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0
  },
  subAccordionLabel: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    minHeight: "0 !important",
    padding: 0,
    "& .MuiAccordionSummary-expandIcon": {
      padding: theme.spacing(0.5, 1)
    }
  },
  accordionLabelContent: {
    flexDirection: "column"
  },
  subAccordionLabelContent: {
    flexDirection: "column",
    marginTop: "0 !important",
    marginBottom: "0 !important",
    "& .mco-filter-item__option-form-control-root": {
      paddingRight: theme.spacing(1)
    },
    "& .mco-filter-item__option-form-control-label .label": {
      overflow: "initial",
      whiteSpace: "initial",
      textOverflow: "initial"
    }
  },
  accordionContent: {
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  },
  subAccordionContent: {
    flexDirection: "column",
    padding: theme.spacing(0, 0, 0, 1)
  },
  optionsWrapper: {
    marginLeft: -12,
    marginRight: -12,
    overflow: "hidden",
    overflowY: "auto",
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: theme.spacing(1),
    scrollbarGutter: "both",
    "& > .mco-filter-item__option": {
      marginBottom: theme.spacing(-1)
    }
  },
  button: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: theme.spacing(1),
    "& button": {
      background: "none !important",
      padding: 0,
      minHeight: 0,
      textTransform: "none",
      fontWeight: 400,
      textDecoration: "underline !important",
      transition: "color 300ms ease",
      "&:hover": {
        color: theme.palette.primary.dark
      }
    }
  }
}));
var _default = exports.default = styles;